import {createContext, useEffect, useReducer, useState} from "react";
import {Client} from "../api/Client";

let defaultValues = {
    loggedIn: false
}

export const BackendContext = createContext(defaultValues);
export const BackendDispatchContext = createContext(null);

const Backend = ({children}) => {

    const reducer = (state, action) => {
        switch (action.type) {
            case('setCurrentUser'):
                return {...state, loggedIn: !!action.user, currentUser: action.user };
            case('hasLoggedIn'):
                return {...state, loggedIn: true, roles: action.roles || []};
                break;
            case('hasLoggedOut'):
            case('noSession'):
                return {...state, loggedIn: false};
                break;
            case('setCountries'):
                return {...state,countries:action.data};
                break;
            case('setLanguages'):
                return {...state,languages:action.data};
                break;
            case('setSettings'):
                return {...state,settings:action.data};
                break;
        }
    }

    const client = new Client()

    defaultValues = {
        ...defaultValues,
        api: {
            login: client.apiLogin,
            getUser: client.apiGetUser,
            deleteUser: client.apiDeleteUser,
            updateUser: client.apiUpdateUser,
            updateUsers: client.apiUpdateUsers,
            getUserManagementUsers: client.apiGetUserManagementUsers,
            searchUserManagementUsers: client.apiSearchUserManagementUsers,
            getUserManagementUser: client.apiGetUserManagementUser,
            setUserActive: client.apiSetUserActive,
            inviteUser: client.apiInviteUser,
            logout: client.apiLogout,
            setUserPassword: client.apiSetUserPassword,
            addUserCredits: client.apiAddUserCredits,
            createUser: client.apiCreateUser,
            getCountries: client.apiGetCountries,
            getLanguages: client.apiGetLanguages,
            getErrorState: client.getErrorState,
            createLicense: client.apiCreateLicense,
            getLicensedUsers: client.apiGetLicensedUsers,
            searchLicensedUsers: client.apiSearchLicensedUsers,
            updateUserLicense: client.apiUpdateUserLicense,
            deleteLicensedUser: client.apiDeleteLicensedUser,
            getSettings: client.apiGetSettings,
            getNotificationSettings: client.apiGetNotificationSettings,
            updateNotificationSettings: client.apiUpdateNotificationSettings,
            getAllDelegations: client.apiGetAllDelegations,
            getDelegationsForUser: client.apiGetDelegationsForUser,
            getGrantedDelegationsForUser: client.apiGetGrantedDelegationsForUser,
            createDelegationForUser: client.apiCreateDelegationForUser,
            updateDelegation: client.apiUpdateDelegation,
            deleteDelegation: client.apiDeleteDelegation,
        },
        countries: [],
        languages: []
    };

    const[state,dispatch] = useReducer(reducer,defaultValues);
    client.setDispatch(dispatch);

    useEffect(() => {
            client.apiGetCountries(null, (resp) => {
                dispatch({type:'setCountries',data:resp})
            }, (error) => {

            })
        },[]
    );

    useEffect(() => {
            client.apiGetLanguages(null, (resp) => {
                dispatch({type:'setLanguages',data:resp})
            }, (error) => {

            })
        },[]
    );

    useEffect(() => {
            client.apiGetSettings(null, (resp) => {
                dispatch({type:'setSettings',data:resp})
            }, (error) => {

            })
        },[]
    );

    return <BackendContext.Provider value={state}>
                <BackendDispatchContext.Provider value={dispatch}>{children}</BackendDispatchContext.Provider>
            </BackendContext.Provider>;
}

export default Backend;